import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const PhoneOutlineIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        viewBox="0 0 24 24"
        sx={{ fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', ...props.sx }}
    >
        <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z" />
    </SvgIcon>
);

export const WarningTriangleOutlineIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        viewBox="0 0 24 24"
        sx={{ fill: 'none', stroke: 'currentColor', strokeWidth: 2.1, strokeLinecap: 'round', strokeLinejoin: 'round', ...props.sx }}
    >
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
        <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
    </SvgIcon>
);

export const WhatsAppOutlineIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        viewBox="0 0 24 24"
        sx={{ fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round', strokeLinejoin: 'round', ...props.sx }}
    >
        <path d="M12 2a10 10 0 0 0-8.6 15l-1.3 4 4.1-1.1A10 10 0 1 0 12 2Z" />
        <path d="M8.5 7.5c.3 0 .6.4.9 1s.6 1.2.4 1.6c-.2.4-.6.6-.4 1.1a6 6 0 0 0 3 3c.5.2.7-.2 1.1-.4.4-.2 1 .1 1.6.4s1 .6 1 .9c0 1-1 2-2 2a9 9 0 0 1-6.9-6.9c0-1 1-2.7 1.3-2.7Z" />
    </SvgIcon>
);
